
import { getAuthState } from '../hooks/useAuth';
import { individualSearchParams } from '../interface/individualSearchInterface';

let auth = getAuthState()
export const individualSearch = async (params: individualSearchParams): Promise<any> => {
    console.log('parametros busca individual: ');
    console.log(params);
    
    
    try {
        auth = getAuthState()

        const {cnpj, cnpj_basico, nome_fantasia, razao_social, nome_socio, cpf, dominio} = params

        if (!(cnpj||cnpj_basico||nome_fantasia||razao_social||nome_socio||cpf||dominio)) {
            return {'statusCode': 400, 'body': 'Erro: Nenhum filtro enviado'}
        }

        const response = await fetch('https://f5gkmqm2yh.execute-api.us-east-1.amazonaws.com/prod/consultaIndividual', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.idToken
            },
            body: JSON.stringify({
                ...(cnpj && { cnpj:cnpj }),
                ...(cnpj_basico && { cnpj_basico:cnpj_basico }),
                ...(nome_fantasia && { nome_fantasia:nome_fantasia }),
                ...(razao_social && { razao_social:razao_social }),
                ...(nome_socio && { nome_socio:nome_socio }),
                ...(cpf && { cpf:cpf }),
                ...(dominio && { dominio:dominio }),
            }),
        });

        const data = await response.json();
        let finalResult
        try {
            finalResult  = JSON.parse(data.body)
        }
        catch {
            finalResult = data.body
        }
        data.body = finalResult
        console.log(data);
        
        return data

    } catch (error) {
        console.error('Error generating leads:', error);
        return [];
    }
};